<template>
  <div>
    <Header name="Indicação de Rede" titleLabel="Indicação de Rede" />
    <omint-page-content>
      <CBox mb="16px">
        <OmtTypography as="h1-bold" lineHeight="32px">Agora, descreva a sua necessidade</OmtTypography>
      </CBox>

      <CBox mb="16px">
        <OmtTypography as="p1" lineHeight="22px">
          Vamos indicar especialistas credenciados de acordo com o que você precisar.
        </OmtTypography>
      </CBox>

      <CBox mb="16px">
        <CFlex align="center">
          <OmtIcons name="fa fa-message-lines" size="lg" color="#4E4E4E" />
          <OmtTypography as="h2-bold" ml="16px">Como podemos te ajudar?</OmtTypography>
        </CFlex>
      </CBox>

      <CBox mb="19px">
        <OmtTypography as="p1" lineHeight="22px">
          Para uma indicação mais assertiva, detalhe a especialidade necessária, seus sintomas, localidade de
          preferência.
        </OmtTypography>
      </CBox>

      <CFlex alignItems="flex-end" flexDirection="column" mb="19px">
        <OmtTextarea
          class="input-observation"
          height="210px"
          padding="12px"
          placeholder="Ex.: Estou com dor de estômago há 5 dias e preciso de um médico localizado na zona sul de São Paulo - SP, próximo ao bairro Itaim Bibi."
          v-model="obs"
          :initialValue="obs"
          :maxLength="250"
          @change="handleChange"
          mb="8px"
        />
        <OmtTypography as="h3-regular" lineHeight="18px" color="var(--colors-light-primary-gray2)">
          {{ obs.length }}/250
        </OmtTypography>
      </CFlex>

      <CBox mb="24px" justify="center" bg="#F6F6F9" p="16px" borderRadius="8px">
        <CFlex align="center">
          <OmtIcons name="fas fa-lightbulb" size="lg" color="#4E4E4E" mr="16px" />
          <OmtTypography as="h3-semi-bold"> O prazo de resposta é de até 2 dias úteis. </OmtTypography>
        </CFlex>
      </CBox>

      <FixedButtonRow>
        <OmtButton
          align-items="center"
          :w="['100%', '308px !important']"
          position="relative"
          :disabled="!obs.length"
          v-chakra
          :colorInverse="true"
          @click="submitForm"
        >
          <OmtTypography
            as="h1-bold"
            :color="!obs.length ? 'var(--colors-light-secondary-disabled-placeholder)' : 'inherit'"
          >
            Enviar
          </OmtTypography>
        </OmtButton>
      </FixedButtonRow>

      <ConfirmationModal
        v-if="showProtocolModal.status"
        :protocol="showProtocolModal.protocol"
        title="Solicitação de indicação de rede realizada com sucesso!"
        detail-icon="bell-on"
        detail-title="O prazo de resposta é de até 2 dias úteis."
        detail-description="Você pode acompanhar o status das suas solicitações pela área “Solicitação de indicação médica”, e será notificado por WhatsApp quando sua solicitação for respondida."
        @action="closeModal"
        @close="closeModal"
      />

      <InfoSendFileModal :isCentered="true" v-if="showInfoModal.status" @close="showInfoModal.status = false" />
    </omint-page-content>
    <Footer />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import Header from "@/components/Molecules/Header";
import Footer from "@/components/Molecules/Footer";
import AffiliateIndicationTile from "@/components/Organisms/AffiliateIndication/Tile";
import InfoSendFileModal from "@/components/Organisms/AffiliateIndication/InfoSendFileModal.vue";
import ConfirmationModal from "@/components/Organisms/ConfirmationModal.vue";
import { CBox, CFlex, CGrid } from "@chakra-ui/vue";
import FixedButtonRow from "@/components/Atoms/FixedButtonRow/index.vue";

export default {
  name: "AffiliateIndicationForm",
  components: {
    Footer,
    Header,
    AffiliateIndicationTile,
    CBox,
    CFlex,
    CGrid,
    ConfirmationModal,
    InfoSendFileModal,
    FixedButtonRow
  },
  data() {
    return {
      obs: "",
      totalFiles: -1,
      limitFiles: 6,
      files: [],
      showInfoModal: {
        status: false
      },
      showProtocolModal: {
        status: false,
        protocol: ""
      }
    };
  },
  methods: {
    ...mapActions("saude", ["uploadFile"]),
    ...mapActions("ticket", ["createNewTicket"]),
    async submitForm() {
      if (!this.obs) return;

      await this.$root.$emit("show-loading");
      let resp = {};
      let files = [];
      this.files.forEach(element => {
        if (element.url) files.push(element.url);
      });

      try {
        resp = await this.createNewTicket({
          obs: this.obs,
          files,
          chamadoReferenciado: null,
          classification: "8973"
        });
      } finally {
        await this.$root.$emit("hide-loading");
      }

      if (resp.Data) {
        this.showProtocolModal.protocol = resp.Data.protocoloANS;
        this.showProtocolModal.status = true;
      } else {
        await Swal.fire({
          title: "Erro",
          text: "Não foi possivel registrar o atendimento.\nServiço temporariamente indisponível.",
          confirmButtonText: "OK",
          icon: "error"
        });
      }
    },
    recreateFiles() {
      const oldFiles = this.files;
      this.files = [];
      oldFiles.forEach(element => {
        this.files.push(element);
      });
    },
    async previewFile(event) {
      await this.$root.$emit("show-loading");
      let resp = {};
      try {
        resp = await this.uploadFile({
          filename: event.target.files[0].filename,
          blobFile: event.target.files[0]
        });
      } finally {
        await this.$root.$emit("hide-loading");
      }
      if (resp.Data && resp.Data[0]) {
        if (resp.Data[0].message !== "OK") {
          await Swal.fire({
            title: "Alerta",
            text: resp.Data[0].message,
            confirmButtonText: "OK",
            icon: "warning"
          });
        } else if (this.totalFiles + resp.Data.length > this.limitFiles - 1) {
          await Swal.fire({
            title: "Alerta",
            text: `O total de imagens e número de páginas PDF não pode ultrapassar ${this.limitFiles}`,
            confirmButtonText: "OK",
            icon: "warning"
          });
        } else {
          for (const file of resp.Data) {
            this.totalFiles++;
            this.files[this.totalFiles] = { thumb: file.thumbUrl, url: file.fileRemoteUrl };
          }
          this.recreateFiles();
        }
      }
    },
    closeModal() {
      this.$router.replace({
        path: "/indicacao-de-credenciados"
      });
    },
    handleChange(obs) {
      this.obs = obs;
    }
  },
  async mounted() {
    for (let i = 0; i < this.limitFiles; i++) {
      this.files.push({ thumb: null, url: null });
    }

    await this.$root.$emit("hide-loading");
  }
};
</script>

<style lang="scss" scoped>
::v-deep .input-observation {
  border: 0.5px solid #dadada;
  color: #8c8c8c !important;
}

::v-deep .input-observation::placeholder {
  color: #8c8c8c !important;
}

.fa-info {
  margin-left: 1rem;
  border-radius: 50%;
  outline: 4px solid currentColor;
  padding: 8px;
  width: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: scale(0.5);
}

.upload-bar {
  margin-top: -25px !important;
  justify-content: space-between;
  flex-wrap: nowrap !important;
}

.upload-bar div {
  margin: 0;
}

.upload-bar div i:first-child {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 20px;
  right: -32px;
  background: #f0f0f0;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  border: 2px solid #112b46;
  color: #112b46;
  font-size: 100%;
}

.upload-bar div input {
  display: none;
}

.upload-bar div img {
  width: 48px;
  height: 48px;
}

.upload-bar div label {
  cursor: pointer;
}

span {
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: var(--colors-light-primary-gray1);
  display: block;
}
</style>
